import { render, staticRenderFns } from "./ExcelUploadPatient.vue?vue&type=template&id=2f99b5fe"
import script from "./ExcelUploadPatient.vue?vue&type=script&lang=js"
export * from "./ExcelUploadPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports